import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";

const BoxModel = (props) => {
  let { ModelID, naam, FabrikantOmschrijving, FabrikantNummer } = props.data;
  const { history } = props;

  ModelID = Number(ModelID);

  return (
    <Paper
      elevation={2}
      style={{ cursor: "pointer" }}
      onClick={() => history.push("/Data/Modellen/" + ModelID)}
    >
      <Grid container justify="space-between">
        <Grid item xs={3}>
          <img
            src={`/media/Model_images/Model-${ModelID}/${ModelID}-Algemeen_min.jpg`}
            // + new Date().getTime();
            style={{
              maxWidth: "calc(97% - 8px)",
              marginLeft: 4,
              marginTop: 4,
              borderRadius: 7,
              border: "black 1px solid",
            }}
            alt={"Afbeelding van een Unimog."}
            onError={(e) => {
              e.target.onError = null;
              e.target.src =
                "/media/Model_images/Placeholder.jpg";
            }}
          ></img>
        </Grid>
        <Grid item xs={9} container justify="space-around" alignItems="stretch">
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {naam}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {FabrikantOmschrijving}
            </Typography>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={7}>
              <Typography noWrap style={{ fontSize: "120%" }}>
                {"art. " + FabrikantNummer}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography noWrap style={{ fontSize: "120%" }}>
                {ModelID <= 1000 ? "wit" : ModelID <= 2000 ? "geel" : "oranje"}
                {" " + ModelID}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BoxModel;
